import { logEvent } from 'firebase/analytics';
import { analyticsPromise } from './firebase';

/**
 * Log a Firebase Analytics event safely.
 * Falls back silently if analytics is unavailable (e.g. ad blockers, tests).
 */
async function log(eventName, params = {}) {
  try {
    const analytics = await analyticsPromise;
    if (analytics) {
      logEvent(analytics, eventName, params);
    }
  } catch {
    // Analytics blocked or unavailable — fail silently
  }
}

/**
 * Track a page view manually (required for React SPA + client-side routing).
 * @param {string} pagePath  e.g. "/", "/faq", "/contact"
 * @param {string} pageTitle e.g. "Home", "FAQ"
 */
export function trackPageView(pagePath, pageTitle) {
  log('page_view', { page_path: pagePath, page_title: pageTitle });
}

/**
 * Track an App Store badge/link click.
 * @param {'hero'|'navbar'|'watch_section'|'faq_cta_banner'|'footer'} location
 */
export function trackAppStoreClick(location) {
  log('app_store_click', { location });
}

/**
 * Track when the user clicks the email link on the Contact page.
 */
export function trackContactEmailClick() {
  log('contact_email_click');
}

/**
 * Track when a key section enters the viewport.
 * @param {'features'|'watch_section'|'notifications'|'faq'} section
 */
export function trackSectionView(section) {
  log('section_view', { section });
}
